import { render, staticRenderFns } from "./ImportsPropertySpaces.vue?vue&type=template&id=4b3e3b42"
import script from "./ImportsPropertySpaces.vue?vue&type=script&lang=js"
export * from "./ImportsPropertySpaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports